(function(){
  var root = document.querySelector('.ladele-tryon');
  if(!root || root.dataset.init) return;
  root.dataset.init = '1';
  var PROXY = root.dataset.proxy;
  var MAX = parseInt(root.dataset.max || '0', 10);
  var CID = root.dataset.customerId || '';
  var CMAIL = root.dataset.customerEmail || '';
  var CREDITS_URL = root.dataset.creditsUrl || '';
  var LOGIN_URL = root.dataset.loginUrl || '/account/login';
  var INGELOGD = !!CID;
  var KEY_FOTO = 'ladele_hand_' + (CID || 'gast');
  var KEY_COUNT = 'ladele_tryon_' + new Date().toISOString().slice(0,10);
  var T = window.LADELE_TRYON_T || {};
  var DEF = {
    saved_photo: 'Je bewaarde foto, klik om te vervangen',
    left_one: 'Nog 1 gratis try-on vandaag',
    left_many: 'Nog {n} gratis try-ons vandaag',
    quota_credits: 'Gratis tegoed voor vandaag is op. Je gebruikt nu credits.',
    quota_out: 'Gratis tegoed voor vandaag is op.',
    quota_login: 'Je gratis tegoed voor vandaag is op. <a href="{login}">Log in</a> om verder te gaan met credits.',
    quota_login_credits: 'Je gratis tegoed voor vandaag is op. <a href="{login}">Log in</a> om verder te gaan met credits, of <a href="{url}">bekijk de credits-bundel</a>.',
    too_large: 'Deze foto is te groot. Kies een kleinere foto.',
    no_image: 'Er kwam geen afbeelding terug. Probeer een scherpere foto, hand recht van boven.',
    credits_left: 'Credits over: {n}',
    no_credits: 'Je credits zijn op.',
    no_credits_buy: 'Je credits zijn op. <a href="{url}">Koop hier 25 extra try-ons</a>.',
    login_credits: '<a href="{login}">Log in</a> om credits te gebruiken.',
    daily_limit: 'De gratis try-on is vandaag niet meer beschikbaar.',
    daily_limit_login: '<a href="{login}">Log in</a> om met credits verder te gaan.',
    traag: 'Het duurde te lang. Controleer je verbinding en probeer het opnieuw.',
    error: 'Er ging iets mis. Probeer het opnieuw.'
  };
  function t(k, v){
    var s = (T[k] != null && T[k] !== '') ? T[k] : DEF[k];
    v = v || {};
    return String(s).replace(/\{(\w+)\}/g, function(m, key){ return (key in v) ? v[key] : m; });
  }
  var handB64=null, handMime=null, designUrl=null, designNaam=null, designLink=null, shape='round';
  function $(id){ return root.querySelector('#'+id); }
  var drop=$('ltDrop'), file=$('ltFile'), go=$('ltGo'), fout=$('ltFout'), laden=$('ltLaden'), res=$('ltRes'), save=$('ltSave'), saveWrap=$('ltSaveWrap');
  function vrij(){ var n=parseInt(localStorage.getItem(KEY_COUNT)||'0',10); return MAX ? Math.max(0, MAX-n) : 999; }
  try {
    var op = localStorage.getItem(KEY_FOTO);
    if(op){ var d=JSON.parse(op); handB64=d.b64; handMime=d.mime;
      $('ltDropTxt').innerHTML = '<img src="data:'+handMime+';base64,'+handB64+'" alt=""><br><small>'+t('saved_photo')+'</small>';
      if(save) save.checked = true; }
  } catch(e){}
  if(saveWrap) saveWrap.hidden = false;
  function teller(){
    if(!MAX) return;
    var v = vrij();
    if(v > 0){ $('ltTeller').textContent = (v===1) ? t('left_one') : t('left_many', {n: v}); }
    else if(INGELOGD){ $('ltTeller').textContent = t('quota_credits'); }
    else { $('ltTeller').textContent = t('quota_out'); }
  }
  function check(){
    var basis = handB64 && designUrl && PROXY;
    if(!basis){ go.disabled = true; return; }
    if(vrij() > 0 || INGELOGD){ go.disabled = false; }
    else {
      go.disabled = true;
      melding(CREDITS_URL ? t('quota_login_credits', {login: LOGIN_URL, url: CREDITS_URL}) : t('quota_login', {login: LOGIN_URL}));
    }
  }
  function melding(h){ fout.innerHTML=h; fout.hidden=false; }
  function bewaar(){ try{ localStorage.setItem(KEY_FOTO, JSON.stringify({b64:handB64,mime:handMime})); }catch(e){} }
  // Verkleint de foto in de browser voor het versturen. Een telefoonfoto van
  // 4 tot 8 MB wordt zo een paar honderd kB: de upload is meteen klaar en de
  // verbinding valt niet meer stil. Google heeft de volle resolutie niet nodig.
  function verklein(dataUrl, klaar){
    var im = new Image();
    im.onload = function(){
      var max = 1600, w = im.width, h = im.height;
      if(w > max || h > max){ var s = Math.min(max/w, max/h); w = Math.round(w*s); h = Math.round(h*s); }
      try {
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        cv.getContext('2d').drawImage(im, 0, 0, w, h);
        var kleiner = cv.toDataURL('image/jpeg', 0.85);
        klaar('image/jpeg', kleiner.split(',')[1], kleiner);
      } catch(e){ klaar(null, dataUrl.split(',')[1], dataUrl); }
    };
    im.onerror = function(){ klaar(null, dataUrl.split(',')[1], dataUrl); };
    im.src = dataUrl;
  }
  function lees(f){
    if(!f) return;
    if(f.size > 25*1024*1024){ melding(t('too_large')); return; }
    var r=new FileReader();
    r.onload=function(){
      verklein(r.result, function(mime, b64, toon){
        handMime = mime || f.type; handB64 = b64;
        $('ltDropTxt').innerHTML='<img src="'+toon+'" alt="">';
        if(save && save.checked) bewaar(); check();
      });
    };
    r.readAsDataURL(f);
  }
  if(save) save.addEventListener('change', function(){ if(save.checked && handB64) bewaar(); else localStorage.removeItem(KEY_FOTO); });
  drop.addEventListener('click', function(){ file.click(); });
  drop.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); file.click(); } });
  drop.addEventListener('dragover', function(e){ e.preventDefault(); drop.classList.add('is-over'); });
  drop.addEventListener('dragleave', function(){ drop.classList.remove('is-over'); });
  drop.addEventListener('drop', function(e){ e.preventDefault(); drop.classList.remove('is-over'); lees(e.dataTransfer.files[0]); });
  file.addEventListener('change', function(e){ lees(e.target.files[0]); });
  Array.prototype.forEach.call(root.querySelectorAll('.lt-shape'), function(b){
    b.addEventListener('click', function(){
      Array.prototype.forEach.call(root.querySelectorAll('.lt-shape'), function(x){ x.classList.remove('is-sel'); });
      b.classList.add('is-sel'); shape=b.dataset.s; });
  });
  Array.prototype.forEach.call(root.querySelectorAll('.lt-design'), function(b){
    b.addEventListener('click', function(){
      Array.prototype.forEach.call(root.querySelectorAll('.lt-design'), function(x){ x.classList.remove('is-sel'); });
      b.classList.add('is-sel'); designUrl=b.dataset.url; designNaam=b.dataset.naam; designLink=b.dataset.link; check(); });
  });
  go.addEventListener('click', function(){
    fout.hidden=true; res.hidden=true; laden.hidden=false; go.disabled=true;
    var metCredits = vrij() <= 0 && INGELOGD;
    // Harde tijdslimiet van 55 seconden zodat een vastgelopen verbinding een
    // nette melding geeft in plaats van de rauwe browserfout "Load failed".
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var killer = ctrl ? setTimeout(function(){ try{ ctrl.abort(); }catch(e){} }, 55000) : null;
    fetch(PROXY, { method:'POST', headers:{'Content-Type':'application/json'}, signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ handImage:handB64, handMime:handMime, designUrl:designUrl, designNaam:designNaam, shape:shape,
        customerId: CID ? 'gid://shopify/Customer/' + CID : null, customerEmail: CMAIL || null, useCredits: metCredits }) })
    .then(function(r){ return r.json().then(function(j){ j._status = r.status; if(!r.ok) throw j; return j; }); })
    .then(function(j){
      if(!j.image) throw { message: t('no_image') };
      $('ltResImg').src=j.image; $('ltDl').href=j.image; $('ltNaar').href=designLink||'#';
      res.hidden=false;
      if(!metCredits){ var n=parseInt(localStorage.getItem(KEY_COUNT)||'0',10)+1; localStorage.setItem(KEY_COUNT,n); }
      teller();
      if(typeof j.creditsLeft === 'number'){ $('ltTeller').textContent = t('credits_left', {n: j.creditsLeft}); }
      res.scrollIntoView({behavior:'smooth',block:'center'});
    })
    .catch(function(e){
      if(e && e.error === 'GEEN_CREDITS'){
        melding(CREDITS_URL ? t('no_credits_buy', {url: CREDITS_URL}) : t('no_credits'));
      } else if(e && e.error === 'LOGIN'){
        melding(t('login_credits', {login: LOGIN_URL}));
      } else if(e && e.error === 'DAGLIMIET'){
        melding(t('daily_limit') + (INGELOGD ? '' : ' ' + t('daily_limit_login', {login: LOGIN_URL})));
      } else if(e && (e.name === 'AbortError' || e.error === 'TIMEOUT')){
        melding(t('traag'));
      } else if(e && e.error){
        melding((e && e.message) || t('error'));
      } else {
        melding(t('error'));
      }
    })
    .then(function(){ if(killer) clearTimeout(killer); laden.hidden=true; check(); });
  });
  teller(); check();
})();
